import { WidgetState } from '../ducks/type';

/**
 * Generate the html id for the widget based on the given widget Id;
 */
export const getWidgetHtmlId = (widgetId: WidgetState['widgetId']) => `widget-${widgetId}`;

/**
 * Generate the html id for the widget's content based on the given widget Id;
 */
export const getWidgetContentHtmlId = (widgetId: WidgetState['widgetId']) => `widget-content-${widgetId}`;

/**
 * Generate the html id for the widget's header based on the given widget Id;
 */
export const getWidgetHeaderHtmlId = (widgetId: WidgetState['widgetId']) => `widget-header-${widgetId}`;
